import axios, { AxiosInstance } from 'axios'

declare const window: Window & typeof globalThis & {
    _globalParams?: {
        location: {
            hostname: string
            port: string
        }
        RequestServerPrefix?: string
    }
}

// Префикс экземпляра mplc ("/N" для экземпляра N > 0, для экземпляра 0 — пусто)
export const requestServerPrefix = () => window?._globalParams?.RequestServerPrefix ?? ''

const instance = () => {
    const location = {
        hostname: window?.location?.hostname ?? '127.0.0.1',
        port: window?.location?.port ?? 8043
    }

    return axios.create({
        baseURL: `//${location.hostname}:${location.port}${requestServerPrefix()}`,
        timeout: 10000,
    });
}

export class Config {
    req: AxiosInstance = instance()
}